import { EndCustomerDto } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { Address } from '../../customers/address.entity';
import { Brands } from '../brands.entity';
import { EndCustomers } from '../end-customer.entity';
import { EndCustomersDTO } from './end-customer.dto';
// import { Address } from '../address.entity';
// import { EndCustomers } from '../endCustomer.entity';
// import { EndCustomerDTO } from './endCustomer.dto';


@Injectable()
export class EndCustomersAdapter {
  /**
   *
   * @param EndCustomersDto
   * @returns EndCustomers entity
   */
  public convertDtoToEntity(endCustomersDTO: EndCustomersDTO, isUpdate: boolean = false): EndCustomers {
    console.log(endCustomersDTO, 'EndCustomersDTO')
    const endCustomer = new EndCustomers();
    endCustomer.endCustomerId = (isUpdate || endCustomersDTO.endCustomerId) ? endCustomersDTO.endCustomerId : undefined;
    endCustomer.endCustomerCode = endCustomersDTO.endCustomerCode;
    endCustomer.endCustomerName = endCustomersDTO.endCustomerName;
    endCustomer.currencyId = endCustomersDTO.currencyId;
    endCustomer.filePath = endCustomersDTO.filePath;
    endCustomer.fileName = endCustomersDTO.fileName;
    endCustomer.isActive = endCustomersDTO.isActive == undefined ? true : endCustomersDTO.isActive;
    endCustomer.consignee = endCustomersDTO.consignee;

    const addressItems: Address[] = [];
    const brandsItems: Brands[] = [];

    if (endCustomersDTO.addressInfo) {
      for (const soItem of endCustomersDTO.addressInfo) {
        const addressObj: Address = new Address();
        addressObj.addLineOne = soItem.addLineOne;
        addressObj.addLineTwo = soItem.addLineTwo;
        addressObj.addLineThree = soItem.addLineThree;
        addressObj.addressType = 'End Customer';
        addressObj.addLineFour = soItem.addLineFour;
        addressObj.createdUser = soItem.createdUser;
        addressItems.push(addressObj);
      }
    }

    if (endCustomersDTO.brandsInfo) {
      for (const soItem of endCustomersDTO.brandsInfo) {
        const brandsObj: Brands = new Brands();
        if (soItem.brandId) {
          brandsObj.brandId = soItem.brandId;
          brandsObj.createdUser = soItem.createdUser;
        }
        brandsObj.brandName = soItem.brandName;
        brandsObj.masterBrandId = soItem.masterBrandId;
        brandsObj.endCustomerId = soItem.endCustomerId;
        brandsItems.push(brandsObj);
      }
    }



    if (isUpdate) {
      endCustomer.updatedUser = endCustomersDTO.updatedUser;
    } else {
      endCustomer.isActive = true;
      endCustomer.createdUser = endCustomersDTO.createdUser;
    }

    endCustomer.addressInfo = addressItems;
    endCustomer.brandsInfo = brandsItems;

    return endCustomer;
  }
  public convertEntityToDto(customersObject: EndCustomers): EndCustomersDTO {
    const endCustomersDTO = new EndCustomersDTO;
    endCustomersDTO.endCustomerId = customersObject.endCustomerId;
    endCustomersDTO.endCustomerCode = customersObject.endCustomerCode;
    endCustomersDTO.endCustomerName = customersObject.endCustomerName;
    endCustomersDTO.currencyId = customersObject.currencyId;
    endCustomersDTO.filePath = customersObject.filePath;
    endCustomersDTO.fileName = customersObject.fileName;
    endCustomersDTO.isActive = customersObject.isActive;
    endCustomersDTO.createdAt = customersObject.createdAt;
    endCustomersDTO.updatedAt = customersObject.updatedAt;
    endCustomersDTO.createdUser = customersObject.createdUser;
    endCustomersDTO.updatedUser = customersObject.updatedUser;
    endCustomersDTO.versionFlag = customersObject.versionFlag;
    endCustomersDTO.addressInfo = customersObject.addressInfo;
    endCustomersDTO.brandsInfo = customersObject.brandsInfo;
    endCustomersDTO.currenciesInfo = customersObject.currencyInfo;
    endCustomersDTO.consignee = customersObject.consignee;
    console.log(customersObject.brandsInfo);
    return endCustomersDTO;
  }
}
